import { FormHelperText } from '@chakra-ui/react'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { MemberProposal } from '../proposedMember'

interface Props {
  proposal: MemberProposal | undefined
  isProposed: boolean
  hasMember: boolean
}

// #123: why the member field holds who it holds, or nobody.
export default function TaskMemberProposalHint({
  proposal,
  isProposed,
  hasMember,
}: Props) {
  const { t } = useTranslation()
  if (!proposal) return null

  if (proposal.kind === 'single') {
    return isProposed ? (
      <FormHelperText>{t('TaskContent.memberProposed')}</FormHelperText>
    ) : null
  }
  if (hasMember) return null
  return (
    <FormHelperText>
      {proposal.kind === 'several'
        ? t('TaskContent.memberSeveral', { names: proposal.names.join(', ') })
        : t('TaskContent.memberVacant')}
    </FormHelperText>
  )
}
